import React from 'react';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Session from '../shared/Session';
import SimpleTable from '../core/SimpleTable';
import Link from '@mui/material/Link';
import { titleCase } from '../shared/Utilities';
import { Button } from '@mui/material';
import openapi_json from '../shared/openapi.json';

export default class Data extends React.Component<any, any> {
    openapi: any = openapi_json;
    view: any = null;
    
    constructor(props: any) {
        super(props);
        this.state = {
            pathLabel: undefined,
            path: undefined,
            data: undefined
        };
        const urlParams = new URLSearchParams(window.location.search);
        this.view = urlParams.get('view');
        if (this.view !== null) {
            this.selectData(titleCase(this.view), "/" + this.view + "/");
        }
    };

    selectData(pathLabel: string, path: string) {
        Session.api("GET", path, {}, (result: any) => {
            this.setState({
                pathLabel: pathLabel,
                path: path,
                data: result
            });
        });
    }

    reloadData() {
        Session.api("GET", this.state.path, {}, (result: any) => {
            this.setState({
                data: result
            });
        });
    }

    render() {
        let dataLinks = [];

        dataLinks.push(
            <>
                <Typography variant="h6" align="left" gutterBottom component="h6">
                    Tables
                </Typography>
            </>
        );

        for (const path in this.openapi.paths) {
            for (const method in this.openapi.paths[path]) {

                // IF THERE IS ANY ROUTE WITH AN ARRAY OF SCHEMA RESPONSES, ADD A DATA LINK.

                if ("responses" in this.openapi.paths[path][method] &&
                    "200" in this.openapi.paths[path][method]["responses"] &&
                    "content" in this.openapi.paths[path][method]["responses"]["200"] &&
                    "application/json" in this.openapi.paths[path][method]["responses"]["200"]["content"] &&
                    "schema" in this.openapi.paths[path][method]["responses"]["200"]["content"]["application/json"] && 
                    "type" in this.openapi.paths[path][method]["responses"]["200"]["content"]["application/json"]["schema"] &&
                    this.openapi.paths[path][method]["responses"]["200"]["content"]["application/json"]["schema"]["type"] === "array") {

                    let pathLabel = titleCase(path);
                    dataLinks.push(
                        <>
                            <Link
                                component="button"
                                variant="body2"
                                onClick={() => {
                                    // let schemaName = path.split("/")[1];
                                    Session.navigate("/data?view=" + path);
                                    this.view = path;
                                    this.selectData(pathLabel, path);
                                    this.forceUpdate();
                                }}
                                >
                                    {pathLabel}
                            </Link>
                            <br />
                        </>
                    );
                }
            }
        }

        dataLinks.push(
            <>
                <Typography variant="h6" align="left" gutterBottom component="h6">
                    Forms
                </Typography>
                <Link
                    component="button"
                    variant="body2"
                    onClick={() => {
                        Session.navigate("/report/new");
                    }}
                >
                    Report Builder
                </Link>
                <br />
                <Link
                    component="button"
                    variant="body2"
                    onClick={() => {
                        Session.navigate("/syntheses");
                    }}
                >
                    Syntheses
                </Link>
                <br />
            </>
        );

        return (
            <>
                <Typography variant="h4" align="left" gutterBottom component="h4">
                    Data
                </Typography>
                <br/>
                {this.view === null ? dataLinks : this.state.data === undefined ? <CircularProgress/> : 
                    <>
                        <Typography variant="h5" align="left" gutterBottom component="h5">
                            {this.state.pathLabel} ({this.state.data.length})
                        </Typography>
                        <Button variant="contained" color="primary" style={{margin: "0.3%"}} onClick={() => {
                                Session.navigate("/data");
                                this.view = null;
                                this.setState({data: undefined});
                        }}>Back</Button>
                        <SimpleTable
                            data={this.state.data}
                            path={this.state.path}
                            dataComponent={this}
                        />
                    </>
                }
            </>
        )
    }
};
